import { RootState } from 'modules'

export const selectOurVariants = (state: RootState): Array<number> | null =>
  state.ourVariants
